import React, { useState, useEffect } from 'react';

import nl2br from '../../../value-converter/nl2br';

const Multiline = ({ params, field }) => {
  const value = params?.value;
  const [clipped, setClipped] = useState(false);

  const handleClick = () => {
    setClipped(false);
  };

  const ContentDiv = "div";
  const ContentPre = "pre";

  if (!field?.pre) {
    return (
      <ContentDiv
        className="multiline-content"
        clipped={clipped}
        dangerouslySetInnerHTML={{ __html: nl2br(value) }}
        onClick={handleClick}
      />
    );
  } else {
    return (
      <ContentPre
        className="multiline-content"
        clipped={clipped}
        onClick={handleClick}
      >
        {value}
      </ContentPre>
    );
  }
};

export default Multiline;
